var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnverifiedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 21,
    height: 21,
    rx: 2.8,
    fill: "#505463"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8594,
    y: -0.700195,
    width: 21,
    height: 21,
    rx: 2.8,
    transform: "rotate(45 13.8594 -0.700195)",
    fill: "#505463"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75781 14.4376L13.0245 17.7042L19.5578 11.1709",
    stroke: "#2E3343",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverifiedDark);
export default __webpack_public_path__ + "static/media/unverified-dark.dbfc03af4bba1d1ecaf132d4ebb0671c.svg";
export { ForwardRef as ReactComponent };